import styled from 'styled-components';

import { Multiselect } from '@dreryk/react-components';

export const StyledServicesMultiselect = styled(Multiselect)`
   width: 300px;
` as typeof Multiselect;
